/* Named storefront interactions. Google delivery is handled by the consent-aware Shopify pixel. */
(function () {
  'use strict';
  if (window.__tbttAnalyticsInstalled) return;
  window.__tbttAnalyticsInstalled = true;
  if (/\/(account|checkouts?|orders)(\/|$)/.test(location.pathname)) return;
  function slug(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }
  function label(el) {
    return (el.getAttribute('aria-label') || el.textContent || el.getAttribute('title') || el.id || el.tagName)
      .replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function placement(el) {
    var dialog = el.closest('dialog');
    if (dialog) return 'dialog_' + (dialog.id || 'details');
    if (el.closest('header')) return 'header';
    if (el.closest('footer')) return 'footer';
    if (el.closest('[aria-label="Delivery timing"]')) return 'post_cutoff_delivery_notice';
    var section = el.closest('section');
    if (section) {
      if (section.id) return section.id;
      if (section.classList.contains('tbtt-hero')) return 'hero';
      if (section.classList.contains('testimonial-strip')) return 'testimonials';
      var heading = section.querySelector('h2,h3');
      if (heading) return slug(heading.textContent).slice(0, 60);
    }
    var nav = el.closest('nav');
    return nav ? slug(nav.getAttribute('aria-label') || 'navigation') : 'page';
  }
  function destination(el) {
    var href = el.getAttribute('href');
    if (!href) return '';
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'phone';
    try {
      var u = new URL(href, location.href);
      if (!/^https?:$/.test(u.protocol)) return '';
      return ((u.origin === location.origin ? '' : u.origin) + u.pathname + u.hash).slice(0, 100);
    } catch (_) { return ''; }
  }
  document.addEventListener('click', function (event) {
    var el = event.target instanceof Element ? event.target.closest('a,button,summary') : null;
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    var text = label(el), where = placement(el), form = el.closest('form');
    var variant = form && form.querySelector('input[name="id"]');
    var identity = el.getAttribute('data-analytics-id') || el.id ||
      el.getAttribute('data-contents-open') || el.getAttribute('aria-controls') || slug(text);
    if (variant && /^\d+$/.test(variant.value)) identity += '_' + variant.value;
    // Disambiguate repeated labels within the same section, such as pack cards.
    var card = el.closest('article');
    var heading = card && card.querySelector('h2,h3');
    if (heading) identity = slug(heading.textContent).slice(0,35) + '_' + identity;
    var result = Shopify.analytics.publish('tbtt_button_click', {
      button_id: (slug(where) + '__' + slug(identity)).slice(0, 100),
      button_label: text,
      button_location: slug(where).slice(0, 60),
      button_destination: destination(el)
    });
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }, true);

  /* A browser form_submit is intent, not proof Shopify accepted the signup. The
     success response or dedicated thank-you page carries this marker. Match it
     to the pre-submit session marker, publish no personal data, and deduplicate
     refreshes within the tab before handing the event to the consent-aware pixel. */
  (function publishConfirmedLead() {
    var marker = document.querySelector('[data-tbtt-lead-conversion]');
    if (!marker) return;
    var source = marker.getAttribute('data-tbtt-lead-conversion');
    if (!/^(landing_page|homepage_popup)$/.test(source)) return;
    var expected = marker.getAttribute('data-tbtt-lead-query');
    if (expected) {
      var separator = expected.indexOf('=');
      if (separator < 1) return;
      var key = expected.slice(0, separator), value = expected.slice(separator + 1);
      if (new URLSearchParams(location.search).get(key) !== value) return;
    }
    var pendingKey = 'tbtt-lead-conversion-pending';
    var convertedKey = 'tbtt-lead-conversion-sent-switch_witch_2026-' + source;
    try {
      if (sessionStorage.getItem(pendingKey) !== source || sessionStorage.getItem(convertedKey)) return;
    } catch (_) { return; }
    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    try {
      sessionStorage.setItem(convertedKey, '1');
      sessionStorage.removeItem(pendingKey);
    } catch (_) { return; }
    var result = Shopify.analytics.publish('tbtt_lead_conversion', {
      lead_magnet: 'switch_witch_2026',
      lead_placement: source
    });
    if (result && typeof result.catch === 'function') result.catch(function () {});
  })();

  /* ArkEngine runs in cross-origin iframes. Its player posts a timecode once per
     second and a video-ended message, so translate those signals into a small,
     consent-aware set of Shopify custom events for the existing GA4 pipeline. */
  var videoDefinitions = {
    cmuyp921400e85ginh8qslpw7: {
      title: 'Tricked by the Treat is Back!',
      location: 'hero',
      duration: 239
    },
    cmu76fx7l00czfpabmcwt175z: {
      title: 'Tricked by the Treat 2.0: Halloween Without the Scary Ingredients',
      location: 'highwire_interview',
      duration: 792
    }
  };
  var videoStates = {};

  Object.keys(videoDefinitions).forEach(function (id) {
    var iframe = document.getElementById('ark-video-' + id);
    if (!iframe) return;
    videoStates[id] = {
      iframe: iframe,
      lastTime: null,
      lastSignalAt: null,
      watched: 0,
      reportedWatch: 0,
      maxTime: 0,
      started: false,
      playing: false,
      completed: false,
      milestones: {},
      pauseTimer: null
    };
  });

  function publishVideo(action, id, state, currentTime, extra) {
    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    var definition = videoDefinitions[id];
    var seconds = Math.max(0, Math.min(definition.duration, Number(currentTime) || 0));
    var payload = {
      video_action: action,
      video_id: id,
      video_title: definition.title,
      video_provider: 'arkengine',
      video_location: definition.location,
      video_current_time: Math.round(seconds),
      video_duration: definition.duration,
      video_percent: Math.min(100, Math.floor(seconds / definition.duration * 100)),
      video_total_watch_seconds: Math.floor(state.watched)
    };
    if (extra) Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    var result = Shopify.analytics.publish('tbtt_video_engagement', payload);
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }

  function flushWatchTime(id, state, currentTime) {
    var unreported = Math.floor(state.watched - state.reportedWatch);
    if (unreported < 1) return;
    publishVideo('engagement', id, state, currentTime, { video_watch_seconds: unreported });
    state.reportedWatch += unreported;
  }

  function schedulePause(id, state) {
    clearTimeout(state.pauseTimer);
    state.pauseTimer = setTimeout(function () {
      if (!state.playing || state.completed) return;
      state.playing = false;
      flushWatchTime(id, state, state.lastTime);
      publishVideo('pause', id, state, state.lastTime);
    }, 2600);
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://app.arkengine.com') return;
    var data = event.data;
    if (!data || data.source !== 'ark-video' || !videoStates[data.id]) return;
    var id = data.id;
    var state = videoStates[id];
    if (event.source !== state.iframe.contentWindow) return;

    if (data.event === 'video-ended') {
      if (state.completed) return;
      clearTimeout(state.pauseTimer);
      state.completed = true;
      state.playing = false;
      state.maxTime = videoDefinitions[id].duration;
      flushWatchTime(id, state, videoDefinitions[id].duration);
      publishVideo('complete', id, state, videoDefinitions[id].duration);
      return;
    }
    if (data.event !== 'timecode') return;

    var currentTime = Number(data.timecode);
    if (!Number.isFinite(currentTime) || currentTime < 0) return;
    var now = Date.now();
    if (state.lastTime === null) {
      state.lastTime = currentTime;
      state.lastSignalAt = now;
      state.maxTime = currentTime;
      return;
    }

    var mediaDelta = currentTime - state.lastTime;
    var wallDelta = Math.max(0, (now - state.lastSignalAt) / 1000);
    var advancing = mediaDelta > 0.05 && mediaDelta <= 3 && wallDelta <= 3;
    state.lastTime = currentTime;
    state.lastSignalAt = now;
    state.maxTime = Math.max(state.maxTime, currentTime);

    if (advancing) {
      state.watched += Math.min(mediaDelta, wallDelta || mediaDelta, 2);
      if (!state.started) {
        state.started = true;
        state.playing = true;
        publishVideo('start', id, state, currentTime);
      } else if (!state.playing) {
        state.playing = true;
        publishVideo('resume', id, state, currentTime);
      }
      if (state.watched - state.reportedWatch >= 15) flushWatchTime(id, state, currentTime);
    }

    if (state.playing) schedulePause(id, state);
    if (!state.started) return;
    [25, 50, 75].forEach(function (milestone) {
      if (!state.milestones[milestone] && state.maxTime / videoDefinitions[id].duration * 100 >= milestone) {
        state.milestones[milestone] = true;
        publishVideo('progress', id, state, currentTime, { video_progress_percent: milestone });
      }
    });
  });
})();
